import React from 'react'
import PropTypes from 'prop-types'

export const Header = ({ children, className = '', ...props }) => (
  <header
    className={`bg-white w-full h-[100px] fixed top-0 left-0 flex justify-between items-center text-2xl font-bold border-b border-[#dee2e6] z-[111] ${className}`}
    {...props}
  >
    {children}
  </header>
)

export const Sidebar = ({ children, className = '', ...props }) => (
  <nav
    className={`bg-white w-[300px] h-full absolute top-[102px] left-0 border-r border-[#dee2e6] overflow-y-auto ${className}`}
    {...props}
  >
    {children}
  </nav>
)

export const FetchingMain = ({ children, className = '', ...props }) => (
  <main
    className={`mt-[100px] ml-[300px] h-[480px] flex justify-center items-center ${className}`}
    {...props}
  >
    {children}
  </main>
)

export const FetchingInputs = ({ children, className = '', ...props }) => (
  <main
    className={`mt-[4%] ml-0 flex justify-center items-center text-xl leading-loose w-full ${className}`}
    {...props}
  >
    {children}
  </main>
)

export const RejectedMain = ({ children, className = '', ...props }) => (
  <main
    className={`mt-[100px] ml-[300px] h-[480px] flex justify-center items-center text-red-600 ${className}`}
    {...props}
  >
    {children}
  </main>
)

export const Button = ({ children, className = '', mode, ...props }) => (
  <button
    className={`rounded border-none text-white h-[35px] w-20 my-3 mx-1 cursor-pointer flex-none flex justify-center items-center transition-colors ${
      mode === 'remove'
        ? 'bg-cancel hover:bg-[#cf2e2e]'
        : 'bg-book hover:bg-[#03a9f4]'
    } ${className}`}
    {...props}
  >
    {children}
  </button>
)

export const ButtonConfirm = ({ children, className = '', mode, ...props }) => (
  <button
    className={`rounded border-none text-white h-[35px] w-20 my-3 mx-1 cursor-pointer flex-none flex justify-center items-center absolute right-[100px] bottom-[1px] transition-colors ${
      mode === 'remove'
        ? 'bg-cancel hover:bg-[#cf2e2e]'
        : 'bg-book hover:bg-[#03a9f4]'
    } ${className}`}
    {...props}
  >
    {children}
  </button>
)

export const ButtonZinkworks = ({ children, className = '', ...props }) => (
  <button
    className={`text-white bg-[rgb(255,0,65)] border border-[rgb(255,0,65)] rounded-sm flex ${className}`}
    {...props}
  >
    {children}
  </button>
)

export const OfficeMain = ({ children, className = '', ...props }) => (
  <main
    className={`mt-[105px] ml-[300px] h-[15px] flex flex-col flex-wrap ${className}`}
    {...props}
  >
    {children}
  </main>
)

const sharedPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

Header.propTypes = sharedPropTypes
Sidebar.propTypes = sharedPropTypes
FetchingMain.propTypes = sharedPropTypes
FetchingInputs.propTypes = sharedPropTypes
RejectedMain.propTypes = sharedPropTypes
OfficeMain.propTypes = sharedPropTypes

Button.propTypes = {
  ...sharedPropTypes,
  mode: PropTypes.oneOf(['remove', 'book']),
}

ButtonConfirm.propTypes = {
  ...sharedPropTypes,
  mode: PropTypes.oneOf(['remove', 'book']),
}

ButtonZinkworks.propTypes = sharedPropTypes

export const ZinkworksLogo = (
  <img className="max-h-[3em] w-auto" src="Zinkworks-Logo.png" alt="Zinkworks. logo" />
)
